<template>
  <hr :class="{ flipped }" :style="{ backgroundColor: fill }" />
</template>

<script>
@Component
class SectionDivider extends Vue {
  @Prop({ type: String, default: 'white' }) fill;
  flipped: Boolean = false;

  created() {
    this.flipped = 'flipped' in this.$attrs;
  }
}

export default SectionDivider;
</script>

<style lang="scss" scoped>
hr {
  position: relative;
  border: none;
  margin: 0;
  width: 100%;
  height: 0;
  overflow: visible;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 40px;
    // background: white;
    background-color: inherit;
    // margin-bottom: -10px;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 20%);
  }

  &.flipped {
    &::after {
      clip-path: polygon(0 0, 100% 0, 100% 20%, 0% 100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionDivider.vue